export default __webpack_public_path__ + "static/media/i_comming.9a0e6317.svg";